import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-semibold" }, "Patient Case", -1)
const _hoisted_2 = { class: "mt-6 md:text-2xl text-lg font-medium text-neutral-600" }
const _hoisted_3 = { class: "md:inline-block block font-semibold text-neutral-900" }
const _hoisted_4 = { class: "w-full lg:p-6 p-4 mx-auto my-6 border border-gray-200 rounded" }
const _hoisted_5 = { class: "flex lg:flex-row flex-col lg:justify-between lg:items-center lg:space-x-[76px] lg:gap-0 gap-6" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "flex pt-4 pb-2 space-x-8 overflow-x-scroll side-scroll"
}
const _hoisted_8 = { class: "flex-shrink-0" }
const _hoisted_9 = { class: "flex-shrink-0" }
const _hoisted_10 = { class: "flex-shrink-0" }
const _hoisted_11 = { class: "flex-shrink-0" }
const _hoisted_12 = { class: "flex-shrink-0" }
const _hoisted_13 = { class: "flex-shrink-0" }
const _hoisted_14 = { class: "flex sm:flex-row flex-col flex-shrink-0 sm:space-x-3 sm:space-y-0 space-y-3" }
const _hoisted_15 = {
  key: 0,
  class: "text-xs font-medium text-red-600"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "w-full my-4 border border-neutral-100" }, null, -1)
const _hoisted_17 = { class: "grid grid-cols-12 gap-6" }

import { ref, onMounted, computed, watch } from "vue";
import UserLayout from "@/layouts/UserLayout.vue";
import SectionTitle from "@/components/partials/SectionTitle.vue";
import { useRouter, useRoute } from "vue-router";
import ErrorModal from "@/components/modals/ErrorModal.vue";
import arrowLeftIcon from "@/components/icons/arrowLeftIcon.vue";
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'IntakeLayout',
  props: {
	isWarningMessage: {
		type: Boolean,
		default: false
	},
	isShowNav: {
		type: Boolean,
		default: true
	},
	patient: {
		type: String,
		default: ''
	},
	isDirty: {
		type: Boolean,
		default: false
	}
},
  setup(__props) {

const props = __props

const router = useRouter();
const route = useRoute();
const patientId = ref<number | null>(route.params.patient);
const caseId = ref<number | null>(route.params.case);
const offlineParams = ref<string>(route.query.offline);
const showModal = ref<boolean>(false)

const navLink = (name) => `/patient/${patientId.value}/cases/${caseId.value}/intake/${name}${offlineParams.value ? '?offline=true' : ''}`;
const routeNav = (name) => useRoute().path.split('/').includes(name);

const closeError = () => {
    showModal.value = false
}

const redirect = (tab: string) => {
	if (!props.isDirty) {
		router.push(tab)
	} else {
		showModal.value = true
	}

}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, {
    hasBack: "",
    backTitle: "Intake Details",
    backLink: `/patient/${patientId.value}/cases/${caseId.value}/intake/view${offlineParams.value ? '?offline=true' : ''}`,
    hasBackClass: "flex md:justify-between md:items-center md:flex-row flex-col"
  }, {
    default: _withCtx(() => [
      _createVNode(ButtonComponent, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push(`/patient/${patientId.value}/cases/${caseId.value}/edit`))),
        customClass: "tertiary text-black hover:text-primary-600 transition lg:pl-4 pl-0 md:py-0 py-0 mt-6"
      }, {
        default: _withCtx(() => [
          _createVNode(arrowLeftIcon, { class: "object-contain w-6 h-6 mr-2" }),
          _hoisted_1
        ]),
        _: 1
      }),
      _createElementVNode("p", _hoisted_2, [
        _createTextVNode("Patient's Name: "),
        _createElementVNode("span", _hoisted_3, _toDisplayString(__props.patient), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (!__props.isShowNav)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _renderSlot(_ctx.$slots, "header")
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("p", {
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (redirect(navLink('personal-information'))), ["prevent"])),
                    class: _normalizeClass(["cursor-pointer", [ routeNav('personal-information') ? 'text-primary-600': 'text-neutral-400']])
                  }, " Personal Information ", 2)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("p", {
                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (redirect(navLink('address-present-location'))), ["prevent"])),
                    class: _normalizeClass(["cursor-pointer", [ routeNav('address-present-location') ? 'text-primary-600': 'text-neutral-400']])
                  }, " Address and Present Location ", 2)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("p", {
                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (redirect(navLink('persons-related-case'))), ["prevent"])),
                    class: _normalizeClass(["cursor-pointer", [ routeNav('persons-related-case') ? 'text-primary-600': 'text-neutral-400']])
                  }, " Persons Related to Case ", 2)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("p", {
                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (redirect(navLink('contact-numbers'))), ["prevent"])),
                    class: _normalizeClass(["cursor-pointer", [ routeNav('contact-numbers') ? 'text-primary-600': 'text-neutral-400']])
                  }, " Contact Numbers ", 2)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("p", {
                    onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (redirect(navLink('email-addresses'))), ["prevent"])),
                    class: _normalizeClass(["cursor-pointer", [ routeNav('email-addresses') ? 'text-primary-600': 'text-neutral-400']])
                  }, " Email Addresses ", 2)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("p", {
                    onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (redirect(navLink('incest-cases'))), ["prevent"])),
                    class: _normalizeClass(["cursor-pointer", [ routeNav('incest-cases') ? 'text-primary-600': 'text-neutral-400']])
                  }, " Incest Cases ", 2)
                ])
              ])),
          _createElementVNode("div", _hoisted_14, [
            _renderSlot(_ctx.$slots, "actionButtons")
          ])
        ]),
        (__props.isDirty)
          ? (_openBlock(), _createElementBlock("p", _hoisted_15, " Kindly save your changes first before browsing through other pages / tabs* "))
          : _createCommentVNode("", true),
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ]),
      _createVNode(ErrorModal, {
        onClose: closeError,
        show: showModal.value,
        content: "You have unsaved changes that will be lost if you leave the page. Please save changes before proceeding."
      }, null, 8, ["show"])
    ]),
    _: 3
  }, 8, ["backLink"]))
}
}

})